export const ListQueryKey = 'newslist';
export const DetailQueryKey = 'news';
export const Urls = {
  selectUrl: '/news/list',
  updateUrl: '/news/update',
  deleteUrl: '/news/delete',
  createUrl: '/news/create',
  detailUrl: '/news/detail'
};